// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3P8Yf","file":"styles_file__pdTkI"};